import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {BehaviorSubject} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  public toggleSidebar$ = new Subject<void>();
  public badgeRefresh$ = new Subject<void>();

  public collapsedSubject = new BehaviorSubject<boolean>(false);
  public collapsed$ = this.collapsedSubject.asObservable();

  constructor() {}

  setCollapsed(isCollapsed: boolean): void {
    this.collapsedSubject.next(isCollapsed);
  }

  collapseSidebar(): void {
    this.collapsedSubject.next(true);
  }

  expandSidebar(): void {
    this.collapsedSubject.next(false);
  }

  refreshBadge(): void {
    this.badgeRefresh$.next();
  }
}
